
import React from "react";
import { 
  Card, 
  CardContent, 
  CardHeader, 
  CardTitle, 
  CardDescription 
} from "@/components/ui/card";
import { ChartPie } from "lucide-react";
import { 
  PieChart, 
  Pie, 
  Cell, 
  Legend, 
  Tooltip, 
  ResponsiveContainer 
} from "recharts";

// User distribution colors
const USER_COLORS = [
  "#8884d8", "#82ca9d", "#ff8042", "#0088FE"
];

interface UserDistributionChartProps {
  userDistribution: {
    name: string;
    value: number;
  }[];
}

const UserDistributionChart = ({ userDistribution }: UserDistributionChartProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <ChartPie className="mr-2 h-5 w-5 text-[#333B44]" />
          User Distribution
        </CardTitle>
        <CardDescription>
          Breakdown of user types in the system
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={userDistribution}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                label={({ name, value }) => `${name}: ${Math.round(value)}`}
              >
                {userDistribution.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={USER_COLORS[index % USER_COLORS.length]} />
                ))}
              </Pie>
              <Legend verticalAlign="bottom" height={36} formatter={(value) => value} />
              <Tooltip formatter={(value) => [Math.round(Number(value)), ""]} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default UserDistributionChart;
